import React from "react";
import { CCol, CFormGroup, CInput, CLabel, CRow } from "@coreui/react";
import { useRemissionNoteFormContext } from "../context/RemissionNoteFormContext";
import { CLIENT_TYPE_GOVERNMENT } from "../../../models/client";
import { getFieldErrors } from "../../../models/errors";
import { FieldErrors } from "../../form/FieldErrors";

const SectionDivider: React.FC<{ icon: string; label: string }> = ({ icon, label }) => (
  <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", marginTop: "16px" }}>
    <div style={{ width: "4px", height: "18px", background: "#f9b115", borderRadius: "2px", marginRight: "10px", flexShrink: 0 }} />
    <i className={`fa ${icon} mr-2`} style={{ fontSize: "0.85rem", color: "#f9b115" }}></i>
    <h6 style={{ margin: 0, fontWeight: 600, color: "var(--theme-muted)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.8px" }}>
      {label}
    </h6>
    <div style={{ flex: 1, height: "1px", background: "var(--theme-divider)", marginLeft: "10px" }} />
  </div>
);

export const RemissionNoteFormDNCPSection: React.FC = () => {
  const {
    remissionNoteRef,
    client,
    errors,
    readonly,
    onDncpContractCodeChange,
    onDncpContractModalityChange,
    onDncpContractEntityChange,
    onDncpContractYearChange,
    onDncpContractSequenceChange,
    onDncpContractDateChange,
  } = useRemissionNoteFormContext();

  if (client?.type !== CLIENT_TYPE_GOVERNMENT) {
    return null;
  }

  return (
    <>
      <SectionDivider icon="fa-handshake-o" label="Datos de Contratación DNCP" />
      <div
        style={{
          background: "var(--theme-warning-surface)",
          border: "1px solid var(--theme-warning-border)",
          borderRadius: "8px",
          padding: "16px 20px",
          marginBottom: "16px",
        }}
      >
      <CRow>
        <CCol xs="12" sm="4" md="2">
          <CFormGroup>
            <CLabel htmlFor="dncpContractModality" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>Modalidad</CLabel>
            <CInput
              id="dncpContractModality"
              placeholder="Modalidad"
              value={remissionNoteRef.current?.dncpContractModality || ""}
              onChange={onDncpContractModalityChange}
              disabled={readonly}
              className={errors.dncpContractModality ? "is-invalid" : ""}
            />
            <FieldErrors
              errors={
                getFieldErrors("dncpContractModality", errors) as string[]
              }
            />
          </CFormGroup>
        </CCol>
        <CCol xs="12" sm="4" md="2">
          <CFormGroup>
            <CLabel htmlFor="dncpContractEntity" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>Entidad</CLabel>
            <CInput
              id="dncpContractEntity"
              placeholder="Entidad"
              value={remissionNoteRef.current?.dncpContractEntity || ""}
              onChange={onDncpContractEntityChange}
              disabled={readonly}
              className={errors.dncpContractEntity ? "is-invalid" : ""}
            />
            <FieldErrors
              errors={getFieldErrors("dncpContractEntity", errors) as string[]}
            />
          </CFormGroup>
        </CCol>
        <CCol xs="12" sm="4" md="2">
          <CFormGroup>
            <CLabel htmlFor="dncpContractYear" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>Año</CLabel>
            <CInput
              id="dncpContractYear"
              placeholder="Año"
              value={remissionNoteRef.current?.dncpContractYear || ""}
              onChange={onDncpContractYearChange}
              disabled={readonly}
              className={errors.dncpContractYear ? "is-invalid" : ""}
            />
            <FieldErrors
              errors={getFieldErrors("dncpContractYear", errors) as string[]}
            />
          </CFormGroup>
        </CCol>
        <CCol xs="12" sm="4" md="2">
          <CFormGroup>
            <CLabel htmlFor="dncpContractSequence" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>Secuencia</CLabel>
            <CInput
              id="dncpContractSequence"
              placeholder="Secuencia"
              value={remissionNoteRef.current?.dncpContractSequence || ""}
              onChange={onDncpContractSequenceChange}
              disabled={readonly}
              className={errors.dncpContractSequence ? "is-invalid" : ""}
            />
            <FieldErrors
              errors={
                getFieldErrors("dncpContractSequence", errors) as string[]
              }
            />
          </CFormGroup>
        </CCol>
        <CCol xs="12" sm="4" md="2">
          <CFormGroup>
            <CLabel htmlFor="dncpContractDate" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>Fecha</CLabel>
            <CInput
              id="dncpContractDate"
              placeholder="Fecha"
              value={remissionNoteRef.current?.dncpContractDate || ""}
              onChange={onDncpContractDateChange}
              disabled={readonly}
              className={errors.dncpContractDate ? "is-invalid" : ""}
            />
            <FieldErrors
              errors={getFieldErrors("dncpContractDate", errors) as string[]}
            />
          </CFormGroup>
        </CCol>
        <CCol xs="12" sm="4" md="2">
          <CFormGroup>
            <CLabel htmlFor="dncpContractCode" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>Código</CLabel>
            <CInput
              id="dncpContractCode"
              placeholder="Código"
              value={remissionNoteRef.current?.dncpContractCode || ""}
              onChange={onDncpContractCodeChange}
              disabled={readonly}
              className={errors.dncpContractCode ? "is-invalid" : ""}
            />
            <FieldErrors
              errors={getFieldErrors("dncpContractCode", errors) as string[]}
            />
          </CFormGroup>
        </CCol>
      </CRow>
      </div>
    </>
  );
};
